import { combineReducers } from 'redux';

import { HomeReducer,LoginReducer } from '../redux';
import RecordReducer from '../redux/records/reducer';

const rootReducer = combineReducers({
  home: HomeReducer,
  login:LoginReducer,
  record:RecordReducer
});
export default rootReducer;

type Reducer = ReturnType<typeof rootReducer>;
export type RootState = Reducer;
